import script from "./TotalOnev3.vue?vue&type=script&setup=true&lang=js"
export * from "./TotalOnev3.vue?vue&type=script&setup=true&lang=js"

import "./TotalOnev3.vue?vue&type=style&index=0&id=9d1e49e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d1e49e2"]])

export default __exports__